import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock } from "lucide-react";
import { Logo } from "../components/Logo";
import { API, setToken, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ivory px-5" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-[#E8E4D9] bg-white p-8 shadow-xl"
        data-testid="admin-login-form"
      >
        <div className="mb-8 flex flex-col items-center">
          <Logo className="h-12 w-auto" />
          <p className="font-mono mt-3 text-[10px] uppercase tracking-[0.3em] text-brand">
            Panel administrativo
          </p>
        </div>
        <label className="mb-1 block text-xs font-bold uppercase tracking-wider text-neutral-500">
          Correo
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
          className="mb-4 w-full rounded-xl border border-[#DDD8C8] bg-white px-4 py-3 text-sm focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20"
          placeholder="admin@landerlandominicana.com"
        />
        <label className="mb-1 block text-xs font-bold uppercase tracking-wider text-neutral-500">
          Contraseña
        </label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
          className="mb-6 w-full rounded-xl border border-[#DDD8C8] bg-white px-4 py-3 text-sm focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20"
          placeholder="••••••••"
        />
        {error && (
          <p className="mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-600" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-3.5 text-sm font-bold text-white transition-colors hover:bg-brand-dark disabled:opacity-60"
        >
          <Lock size={16} />
          {loading ? "Entrando…" : "Entrar al panel"}
        </button>
        <a href="/" className="mt-5 block text-center text-xs text-neutral-400 hover:text-brand" data-testid="admin-back-to-site">
          ← Volver al sitio
        </a>
      </form>
    </div>
  );
}
